"use client";
import { USER_PHOTO } from "@/config/interface";
import { FmIcon, FmImage } from "@/ui-component";
import Loading from "./TryonLoading";
import stl from "./imageTryon.module.scss";
import classnames from "classnames";
import { useCallback, useMemo } from "react";
import { useCommonContext } from "@/src/provider/Common/context";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";
interface ImageModalProps {
    currImg: any;
    imgList: any;
    onClickUpload: () => void;
    onSelectVisibleImg: (item: any) => void;
    deleteImg: (item: any, index: number) => void;
    loading: boolean;
}

const ImageModal: React.FC<ImageModalProps> = (props) => {
    const { onClickUpload, onSelectVisibleImg, deleteImg } = useMemo(
        () => props,
        [props],
    );

    const { t } = useTranslation("common");

    const handleSelectVisibleImg = useCallback(
        (item: USER_PHOTO) => {
            onSelectVisibleImg(item);
        },
        [onSelectVisibleImg],
    );
    const loadingDom = useMemo(() => {
        return props.loading ? (
            <div className={stl["loading-dom"]}>
                <Loading color={variable.main} />
            </div>
        ) : (
            <div
                className={classnames(stl["upload"], "gtm-img-try-on-upload")}
                onClick={onClickUpload}
                dangerouslySetInnerHTML={{
                    __html: t("common:ImgTryOn.UploadAPicture"),
                }}
            ></div>
        );
    }, [onClickUpload, props.loading, t]);

    const imgListDom = useMemo(() => {
        return props.imgList.map((item: USER_PHOTO, idx: number) => (
            <div
                key={item.photo_id}
                className={classnames(stl["img-item-box"])}
            >
                <FmImage
                    onClick={() => handleSelectVisibleImg(item)}
                    image={item.photo_img}
                />
                {props.currImg &&
                    props.currImg.photo_id === item.photo_id &&
                    item.customerEyePhotoType === 2 && (
                        <FmIcon
                            icon={"icon--close"}
                            className={classnames(
                                stl["circle-bg"],
                                "gtm-img-try-on-del",
                            )}
                            onClick={() => deleteImg(item, idx)}
                            style={{
                                ...(props.currImg &&
                                props.currImg.photo_id === item.photo_id
                                    ? { display: "flex" }
                                    : {}),
                            }}
                        />
                    )}
            </div>
        ));
    }, [deleteImg, handleSelectVisibleImg, props.currImg, props.imgList]);
    return (
        <div className={classnames(stl["bottom-box"])}>
            <div className={classnames(stl["img-line"])}>
                {loadingDom}
                {imgListDom}
            </div>
        </div>
    );
};

export default ImageModal;
